"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ constructor(initialState){
        // eslint-disable-next-line no-console
        this.score = 0;
        this.status = "idle";
        this.initialState = initialState ? initialState.map((row)=>[
                ...row
            ]) : Array.from({
            length: 4
        }, ()=>Array(4).fill(0));
        this.board = this.initialState.map((row)=>[
                ...row
            ]);
    }
    moveLeft() {
        const oldBoard = this.getState();
        this.board.forEach((row, i)=>{
            const newRow = row.filter((cell)=>cell !== 0);
            for(let j = 0; j < newRow.length - 1; j++)if (newRow[j] === newRow[j + 1]) {
                newRow[j] = newRow[j] * 2;
                this.score += newRow[j];
                newRow[j + 1] = 0;
                j++;
            }
            this.board[i] = newRow.filter((cell)=>cell !== 0);
            while(this.board[i].length < 4)this.board[i].push(0);
        });
        this.chechGameOver();
        if (!this.boardsAreEqual(oldBoard, this.board)) this.addRandomTile();
    }
    moveRight() {
        const oldBoard = this.getState();
        this.board.forEach((row, i)=>{
            const newRow = row.filter((cell)=>cell !== 0);
            for(let j = newRow.length - 1; j > 0; j--)if (newRow[j] === newRow[j - 1]) {
                newRow[j] = newRow[j] * 2;
                this.score += newRow[j];
                newRow[j - 1] = 0;
                j--;
            }
            this.board[i] = newRow.filter((cell)=>cell !== 0);
            while(this.board[i].length < 4)this.board[i].unshift(0);
        });
        this.chechGameOver();
        if (!this.boardsAreEqual(oldBoard, this.board)) this.addRandomTile();
    }
    moveUp() {
        const oldBoard = this.getState();
        for(let i = 0; i < 4; i++){
            const col = [];
            for(let j = 0; j < 4; j++)col.push(this.board[j][i]);
            let newCol = col.filter((cell)=>cell !== 0);
            for(let j = 0; j < newCol.length - 1; j++)if (newCol[j] === newCol[j + 1]) {
                newCol[j] = newCol[j] * 2;
                this.score += newCol[j];
                newCol[j + 1] = 0;
                j++;
            }
            newCol = newCol.filter((cell)=>cell !== 0);
            while(newCol.length < 4)newCol.push(0);
            for(let j = 0; j < 4; j++)this.board[j][i] = newCol[j];
        }
        this.chechGameOver();
        if (!this.boardsAreEqual(oldBoard, this.board)) this.addRandomTile();
    }
    moveDown() {
        const oldBoard = this.getState();
        for(let i = 0; i < 4; i++){
            const col = [];
            for(let j = 0; j < 4; j++)col.push(this.board[j][i]);
            let newCol = col.filter((cell)=>cell !== 0);
            for(let j = newCol.length - 1; j > 0; j--)if (newCol[j] === newCol[j - 1]) {
                newCol[j] = newCol[j] * 2;
                this.score += newCol[j];
                newCol[j - 1] = 0;
                j--;
            }
            newCol = newCol.filter((cell)=>cell !== 0);
            while(newCol.length < 4)newCol.unshift(0);
            for(let j = 0; j < 4; j++)this.board[j][i] = newCol[j];
        }
        this.chechGameOver();
        if (!this.boardsAreEqual(oldBoard, this.board)) this.addRandomTile();
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return this.board.map((row)=>[
                ...row
            ]);
    }
    start() {
        this.score = 0;
        this.board = Array.from({
            length: 4
        }, ()=>Array(4).fill(0));
        this.status = "playing";
        this.addRandomTile();
    }
    getStatus() {
        return this.status;
    }
    /**
   * Returns the current game status.
   *
   * @returns {string}

  start() {
    this.score = 0;
    this.board = Array.from({ length: 4 }, () => Array(4).fill(0));
    this.status = 'playing';
    this.addRandomTile();
  }

  /**
   * Resets the game.
   */ restart() {
        this.board = this.initialState.map((row)=>[
                ...row
            ]);
        this.score = 0;
        this.status = "idle";
    }
    boardsAreEqual(board1, board2) {
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++){
            if (board1[i][j] !== board2[i][j]) return false;
        }
        return true;
    }
    addRandomTile() {
        const mas = this.getRandomTile();
        const numberRandom = Math.floor(Math.random() * mas.length);
        const number = Math.random() < 0.9 ? 2 : 4;
        this.board[mas[numberRandom].i][mas[numberRandom].j] = number;
    }
    getRandomTile() {
        const masEmpty = [];
        for(let i = 0; i < 4; i++){
            for(let j = 0; j < 4; j++)if (this.board[i][j] === 0) masEmpty.push({
                i: i,
                j: j
            });
        }
        return masEmpty;
    }
    chechGameOver() {
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++){
            if (this.board[i][j] === 2048) {
                this.status = "win";
                return;
            }
            if (this.board[i][j] === 0) return;
            if (i < 3 && this.board[i][j] === this.board[i + 1][j]) return;
            if (j < 3 && this.board[i][j] === this.board[i][j + 1]) return;
        }
        this.status = "lose";
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$gameScore = document.querySelector(".game-score");
const $09e991522ca7e64e$var$buttonStart = document.querySelector(".button");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$tilesContainer = document.querySelector(".tiles-container");
let $09e991522ca7e64e$var$tilesMap = {};
function $09e991522ca7e64e$var$showMessage(message) {
    switch(message){
        case "lose":
            $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
            break;
        case `win`:
            $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
            break;
        default:
    }
}
function $09e991522ca7e64e$var$updateScore(score) {
    $09e991522ca7e64e$var$gameScore.textContent = score;
}
function $09e991522ca7e64e$var$updateBoard(board) {
    const newTilesMap = {};
    board.forEach((row, y)=>{
        row.forEach((value, x)=>{
            const key = `${x}-${y}`;
            if (value === 0) {
                if ($09e991522ca7e64e$var$tilesMap[key]) $09e991522ca7e64e$var$tilesContainer.removeChild($09e991522ca7e64e$var$tilesMap[key]);
                return;
            }
            if ($09e991522ca7e64e$var$tilesMap[key]) {
                $09e991522ca7e64e$var$tilesMap[key].style.transition = "transform 1.15s ease-in-out";
                $09e991522ca7e64e$var$tilesMap[key].textContent = value;
                $09e991522ca7e64e$var$tilesMap[key].className = `tile tile--${value}`;
                $09e991522ca7e64e$var$tilesMap[key].style.transform = `translate(${x * 90}px, ${y * 90}px) scale(1)`;
                newTilesMap[key] = $09e991522ca7e64e$var$tilesMap[key];
            } else {
                const tile = document.createElement("div");
                tile.classList.add("tile", `tile--${value}`);
                tile.textContent = value;
                tile.style.transform = `translate(${x * 90}px, ${y * 90}px) scale(0.5)`;
                $09e991522ca7e64e$var$tilesContainer.appendChild(tile);
                requestAnimationFrame(()=>{
                    tile.style.transition = "transform 0.25s ease-in-out";
                    tile.style.transform = `translate(${x * 90}px, ${y * 90}px) scale(1)`;
                });
                newTilesMap[key] = tile;
            }
        });
    });
    $09e991522ca7e64e$var$updateScore($09e991522ca7e64e$var$game.getScore());
    $09e991522ca7e64e$var$tilesMap = newTilesMap;
}
$09e991522ca7e64e$var$buttonStart.addEventListener("click", (e)=>{
    if (!$09e991522ca7e64e$var$game || $09e991522ca7e64e$var$game.getStatus() !== "playing") {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$buttonStart.textContent = "Restart";
        $09e991522ca7e64e$var$buttonStart.className = "button restart";
    } else {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$buttonStart.textContent = "Start";
        $09e991522ca7e64e$var$buttonStart.className = "button start";
    }
    $09e991522ca7e64e$var$updateBoard($09e991522ca7e64e$var$game.getState());
    $09e991522ca7e64e$var$updateScore($09e991522ca7e64e$var$game.getScore());
    $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    $09e991522ca7e64e$var$messageLose.classList.add("hidden");
});
document.addEventListener("keydown", (e)=>{
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") // eslint-disable-next-line no-useless-return
    return;
    switch(e.key){
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            break;
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            break;
        default:
    }
    $09e991522ca7e64e$var$updateBoard($09e991522ca7e64e$var$game.getState());
    $09e991522ca7e64e$var$messageLose.classList.add("hidden");
    $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    $09e991522ca7e64e$var$showMessage($09e991522ca7e64e$var$game.getStatus());
});
const $09e991522ca7e64e$var$themeSwitch = document.getElementById("switch");
$09e991522ca7e64e$var$themeSwitch.addEventListener("change", ()=>{
    document.body.classList.toggle("dark", $09e991522ca7e64e$var$themeSwitch.checked);
    document.querySelectorAll("p").forEach((p)=>{
        p.style.color = $09e991522ca7e64e$var$themeSwitch.checked ? "#fff" : "#333";
    });
    document.querySelector(".dark-check--p").textContent = $09e991522ca7e64e$var$themeSwitch.checked ? "DARK" : "LIGHT";
});
let $09e991522ca7e64e$var$startX = 0;
let $09e991522ca7e64e$var$startY = 0;
const $09e991522ca7e64e$var$gameContainer = document.querySelector(".game-container");
$09e991522ca7e64e$var$gameContainer.addEventListener("touchstart", (e)=>{
    e.preventDefault();
    const touch = e.touches[0];
    $09e991522ca7e64e$var$startX = touch.clientX;
    $09e991522ca7e64e$var$startY = touch.clientY;
}, {
    passive: false
});
$09e991522ca7e64e$var$gameContainer.addEventListener("touchend", (e)=>{
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    const touch = e.changedTouches[0];
    const diffX = touch.clientX - $09e991522ca7e64e$var$startX;
    const diffY = touch.clientY - $09e991522ca7e64e$var$startY;
    if (Math.abs(diffX) > Math.abs(diffY)) {
        if (diffX > 0) $09e991522ca7e64e$var$game.moveRight();
        else $09e991522ca7e64e$var$game.moveLeft();
    } else if (Math.abs(diffY) > 0) {
        if (diffY > 0) $09e991522ca7e64e$var$game.moveDown();
        else $09e991522ca7e64e$var$game.moveUp();
    }
    $09e991522ca7e64e$var$updateBoard($09e991522ca7e64e$var$game.getState());
    $09e991522ca7e64e$var$messageLose.classList.add("hidden");
    $09e991522ca7e64e$var$messageWin.classList.add("hidden");
    $09e991522ca7e64e$var$showMessage($09e991522ca7e64e$var$game.getStatus());
}, {
    passive: false
});


//# sourceMappingURL=index.a4f156f8.js.map
